'use client';

import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

// Utility function to filter props
const shouldForwardProp = (prop) => prop !== 'nopadding';

export const MainGrid = styled(Grid, { shouldForwardProp })(({ theme, nopadding }) => ({
  minHeight: '100vh',
  maxWidth: '1120px',
  margin: '30px auto 100px auto',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    padding: '0 16px',
    margin: '20px auto 120px auto',
  },
  [theme.breakpoints.down('md')]: !nopadding && {
    paddingRight: '24px',
    paddingLeft: '24px',
  },
}));

export default MainGrid;
